/**
 * Flags whether and element is filled or not
 * @module embed/is_filled
 */

import { delegate } from '@/lib/events';

const SELECTOR = 'input, select, textarea';
const CLASS_IS_FILLED = 'is-filled';

export function renderIsFilled(el) {
  if (el.value) {
    el.classList.add(CLASS_IS_FILLED);
  } else {
    el.classList.remove(CLASS_IS_FILLED);
  }
}

/**
 * @param {HTMLElement} el The element on which to listen to change events
 */
export function setupIsFilled(el) {
  el.addEventListener(
    'change',
    delegate(SELECTOR, (e, target) => {
      renderIsFilled(target);
    })
  );
  Array.from(el.querySelectorAll(SELECTOR)).forEach(renderIsFilled);
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/is_filled.js